export const timePickerStyles = {
  rootAfter: {
    display: "none"
  }
};
